import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }

import TextFieldStandard from '@/design-system/atoms/TextFieldStandard.vue'
import SimpleFormModal from './SimpleFormModal.vue'
import { computed, ref, toRefs, watch } from 'vue'
import { validateInput, Input } from './inputValidation'

type Props = {
  title: string
  inputs: Input[]
  submitButtonText?: string
  open?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BasicTextInputModal',
  props: {
    title: {},
    inputs: {},
    submitButtonText: { default: 'Submit' },
    open: { type: Boolean, default: false }
  },
  emits: ["submit", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const { title, submitButtonText } = toRefs(props)

const emit = __emit

const isOpen = ref(props.open)
const values = ref<Record<string, string | number>>({})

const validationResults = computed<Record<string, { result: boolean; message?: string }>>(() => {
  const results: Record<string, { result: boolean; message?: string }> = {}
  props.inputs.forEach((input) => {
    const value = values.value[input.key]
    if (value !== undefined) {
      const validationResult = validateInput(input, value)
      results[input.key] = validationResult
    } else {
      results[input.key] = { result: true }
    }
  })
  return results
})

const isValid = computed(() => {
  return Object.values(validationResults.value).every((result) => result.result)
})

const submitDisabled = computed(() => {
  return (
    props.inputs.some((input) => {
      const value = values.value[input.key]
      return input.required && (!value || value === '')
    }) || !isValid.value
  )
})

watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue
  },
  { immediate: true }
)

const handleInput = (key: string, input: number | string) => {
  values.value[key] = input
}

const handleSubmit = () => {
  if (!submitDisabled.value) {
    isOpen.value = false
    emit('submit', values.value)
  }
}

const handleClose = () => {
  isOpen.value = false
  // Reset values when closing the modal
  values.value = {}
  // reste validation results
  for (const input of props.inputs) {
    validationResults.value[input.key] = { result: true }
  }
  // Emit close event
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleFormModal, {
    title: _unref(title),
    "submit-button-text": _unref(submitButtonText),
    open: isOpen.value,
    "disable-submit": submitDisabled.value,
    onClose: handleClose,
    onSubmit: handleSubmit
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputs, (input, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: input.key,
            class: "input-container"
          }, [
            _createVNode(TextFieldStandard, {
              focus: index === 0,
              disabled: input.textFieldDisabled,
              hideIconX: true,
              label: input.label,
              prefilledText: input.prefilledText,
              required: input.required,
              type: input.type,
              error: validationResults.value[input.key]?.result === false,
              "error-message": '* ' + validationResults.value[input.key]?.message,
              "help-text": input.helpText,
              onEmitInput: (value) => handleInput(input.key, value)
            }, null, 8, ["focus", "disabled", "label", "prefilledText", "required", "type", "error", "error-message", "help-text", "onEmitInput"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["title", "submit-button-text", "open", "disable-submit"]))
}
}

})